export const ACCESS_ENDPOINTS = {
  ME: '/v2/permissions/me',
  SITE_ACCESS: '/v2/permissions/site-access',
  SIDEBAR: '/v2/permissions/menu',
} as const;
